// 引入路由和storage工具函数
import {removeItem, clear, getItem, setItem} from "@/utils/auth";
import store from '@/store'
import {Notification} from "element-ui";
import { MessageBox } from "element-ui";
import router from "@/router";
import Cookies from "js-cookie";

let lastTime = new Date().getTime()
let currentTime = new Date().getTime()
let timeOut =120 * 60 * 1000 //设置超时时间: 120分钟
let operateInterval = setInterval(checkTimeout, 30000);

window.onload = function () {
  checkTimeout();
  window.document.onmousedown = function () {
    setItem("lastTime", new Date().getTime())
  }
};

function checkTimeout() {
  currentTime = new Date().getTime()		//更新当前时间
  lastTime = getItem("lastTime");
  if (currentTime - lastTime > timeOut) { //判断是否超时
    window.document.onmousedown = null;
    window.clearInterval(operateInterval);
    // 清除storage的数据(登陆信息和token)
    //  clear()
    // 跳到登陆页
    if (router.app._route.path!== "/login" && router.app._route.path!== "/register" && router.app._route.path!== "/resetPwd") {
      console.log("长时间无操作，退出登录")
      MessageBox.confirm('长时间无操作，退出登录?', '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        closeOnClickModal: false,
        customClass: 'messageBox',
        type: 'warning'
      }).then(() => {
        store.dispatch('user/logOut').then(() => {
          location.reload();
        })
      }).catch(() => {
        store.dispatch('user/logOut').then(() => {
          location.reload();
        })
      });

    }
  }
}

export default function () {
  /* 定时器 间隔30秒检测是否长时间未操作页面 */
  // window.setInterval(checkTimeout, 30000);
}





// WEBPACK FOOTER //
// ./src/utils/astrict.js